import { z } from 'zod';

export const PivotCellSchema = z.object({
  cellId: z.string(),
  demandComponent: z.string(),
  editable: z.boolean(),
  notes: z.string().nullable(),
  rowId: z.string(),
  value: z.number(),
  year: z.string(),
});

export type IPivotCell = z.infer<typeof PivotCellSchema>;

export const ReportPivotResponseSchema = z.object({
  cells: z.array(PivotCellSchema),
  reportId: z.number().int().positive(),
  reportName: z.string(),
  reportNotes: z.string().nullable(),
  years: z.array(z.string()),
});

export type IReportPivotResponse = z.infer<typeof ReportPivotResponseSchema>;

export const SaveReportCellChangeSchema = z.object({
  cellId: z.string(),
  newValue: z.number(),
  notes: z.string().nullable().optional(),
  rowId: z.string(),
  year: z.string(),
});

export type ISaveReportCellChange = z.infer<typeof SaveReportCellChangeSchema>;

export const SaveReportCellsRequestSchema = z.object({
  changes: z.array(SaveReportCellChangeSchema).min(1),
});

export type ISaveReportCellsRequest = z.infer<
  typeof SaveReportCellsRequestSchema
>;

export const ReportExportFormatSchema = z.enum(['csv', 'xlsx']);

export type IReportExportFormat = z.infer<typeof ReportExportFormatSchema>;

export const ReportExportResponseSchema = z.object({
  contentBase64: z.string(),
  contentType: z.string(),
  fileName: z.string(),
  format: ReportExportFormatSchema,
});

export type IReportExportResponse = z.infer<typeof ReportExportResponseSchema>;
